<template>
  <div id="form-crud-finishing">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    <div class="card border-0 shadow p-3">
      <form @submit.prevent="initSubmit">

        <div class="form-group">
          <label for="number">Uid *</label>
          <input class="form-control" id="uid" v-model="finishing.uid" type="text">
          <div v-if="errorsForm.uid">
            <p class="form-error text-danger" v-for="(error, index) in errorsForm.uid.errors" :key="index">
              {{ error }}
            </p>
          </div>
        </div>

        <div class="form-group">
          <label for="number">{{ $t('common.name') }} *</label>
          <input class="form-control" id="number" v-model="finishing.name" type="text">
          <div v-if="errorsForm.name">
            <p class="form-error text-danger" v-for="(error, index) in errorsForm.name.errors" :key="index">
              {{ error }}
            </p>
          </div>
        </div>

        <input type="submit" class="btn mt-4 mb-2 btn-success" :value="valueButtonSubmit" />
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    finishing: Object,
    id: Number,
    actionForm: String
  },
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      },
      errorsForm: [],
    }
  },
  created: function() {
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
    /*----------------- SUBMIT ------------------*/
    initSubmit()
    {
      // If finishing (create or update)
      if(this.actionForm === 'edit') {
        this.edit()
      } else {
        this.create()
      }
    },
    /**
     * Create finishing (submit form)
     */
    create() {

      this.showLoader()

      this.$store.dispatch('createFinishing', this.finishing)
          .then(() => {
            this.hideLoader()
            this.redirectAndRefresh()
          })
          .catch((errors) => {
            this.hideLoader()
            this.errorsForm = errors
          })
    },
    /**
     * Update finishing (submit form)
     */
    edit() {
      this.showLoader()

      this.$store.dispatch('updateFinishing', { id: this.finishing.id, finishing: this.finishing })
          .then(() => {
            this.hideLoader()
            this.redirectAndRefresh()
          })
          .catch((errors) => {
            this.hideLoader()
            this.errorsForm = errors
          })
    },
    /**
     * Redirect to finishing-list after submit
     * Refresh ErrorsForm
     */
    redirectAndRefresh()
    {
      // Redirect
      this.$router.push({ name: 'finishing-index' })

      // Refresh errors form
      this.errorsForm = []
    }
  },
  computed: {
    /**
     * Display value for button submit
     * @returns {string}
     */
    valueButtonSubmit() {
      let value = ''
      if(this.actionForm === 'edit')
      {
        value = this.$t('pages.finishing.editFinishing')
      }
      else {
        value = this.$t('pages.finishing.createFinishing')
      }

      return value
    },
    ...mapState(['FinishingModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay')
  }
}
</script>
